import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { ROUTE_BASE_URL } from "../../api/common";
import Header from "./Header";
import { convertDBDate } from "./common";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import { GetMemberInfo } from "./Api/services/Webservices";
import Footer from "./Footer";
import { encryptSlug, decryptSlug } from "../../util/encryption";
import axios from "axios";
import { baseUrl } from "../../api/common";
const KnownUserMemberApplication = () => {
  const { slug } = useParams();
  const decryptedId = decryptSlug(slug);
  const [memberDetails, setMemberDetails] = useState({});
  const [contactAMASIModal, setContactAMASIModal] = useState(false);

  const [contactAMASIFormValues, setContactAMASIFormValues] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    mobile_number: "",
    member_no: "",
    subject: "",
    message: "",
  });

  const [contactAMASIErrors, setContactAMASIErrors] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    mobile_number: "",
    member_no: "",
    subject: "",
    message: "",
  });
  const handleInputChange = (field, value) => {
    setContactAMASIFormValues({ ...contactAMASIFormValues, [field]: value });
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append("id", decryptedId);
    const MemberFormdata = formData;
    GetMemberInfo(MemberFormdata)
      .then((res) => {
        if (res.status === true && res.data && res.data.length > 0) {
          const details = res.data[0];
          setMemberDetails(details);
        }
      })
      .catch((error) => {
        showToast(error.message || "An error occurred", "error");
      });
  }, []);

  const handleContactAMASIModalOpen = () => {
    setContactAMASIModal(true);
  };
  const handleContactAMASIModalClose = () => {
    setContactAMASIModal(false);
  };
  const validate = () => {
    const errors = {
      first_name: "",
      last_name: "",
      email_id: "",
      mobile_number: "",
      member_no: "",
      subject: "",
      message: "",
    };
    if (!contactAMASIFormValues.first_name) {
      errors.first_name = "First Name cannot be empty";
    }
    // if (!contactAMASIFormValues.last_name) {
    //   errors.last_name = 'Last Name cannot be empty';
    // }
    if (!contactAMASIFormValues.email_id) {
      errors.email_id = "Email ID cannot be empty";
    } else if (!/\S+@\S+\.\S+/.test(contactAMASIFormValues.email_id)) {
      errors.email_id = "Email ID is invalid";
    }
    if (!contactAMASIFormValues.mobile_number) {
      errors.mobile_number = "Mobile Number cannot be empty";
    }
    // else if (!/^\d{10}$/.test (contactAMASIFormValues.mobile_number)) {
    //   errors.mobile_number = 'Mobile Number must be 10 digits';
    // }
    if (!contactAMASIFormValues.member_no) {
      errors.member_no = "Membership Number cannot be empty";
    }
    if (!contactAMASIFormValues.subject) {
      errors.subject = "Subject cannot be empty";
    }
    if (!contactAMASIFormValues.message) {
      errors.message = "Message cannot be empty";
    }
    setContactAMASIErrors(errors);
    return Object.values(errors).every((error) => error === "");
  };

  const clearContactAMASIFormValues = () => {
    setContactAMASIFormValues({
      first_name: "",
      last_name: "",
      email_id: "",
      mobile_number: "",
      member_no: "",
      subject: "",
      message: "",
    });
    setContactAMASIErrors({
      first_name: "",
      last_name: "",
      email_id: "",
      mobile_number: "",
      member_no: "",
      subject: "",
      message: "",
    });
    handleContactAMASIModalClose();
  };

  const handleContactAMASIFormSubmit = async () => {
    if (!validate()) {
      return;
    }
    try {
      console.log("contact AMASI Form Values:", contactAMASIFormValues);
      const response = await axios.post(
        `${baseUrl}/api/enquiry_form`,
        contactAMASIFormValues,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        showToast(response.data.message, "success");
        clearContactAMASIFormValues();
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error approving application status:", error);
    }
  };
  const sendDetailsToMail = async (id) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/send_details_toMail`,
        {
          id: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        showToast(response.data.message, "success");
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };
  return (
    <div className="user_application_div_clr user_tab">
      <ToastMessage />
      <section className="user_div_total">
        <Header />
        {memberDetails && (
          <div className="container pt-50">
            <div className="row">
              <div className="col-md-12">
                <div className="tracking_head">
                  <h2>Know your AMASI Membership Number</h2>
                </div>
              </div>
              <div className="col-md-12">
                <div className="card">
                  <div className="body application_text_style">
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Name</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={`${
                              memberDetails.salutation
                                ? memberDetails.salutation
                                : ""
                            }${
                              memberDetails.first_name
                                ? memberDetails.first_name
                                : ""
                            }${
                              memberDetails.middle_name
                                ? " " + memberDetails.middle_name
                                : ""
                            }${
                              memberDetails.last_name
                                ? " " + memberDetails.last_name
                                : ""
                            }`}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Membership Number</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={memberDetails.membership_no}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Email</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={memberDetails.email}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Phone Number</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={memberDetails.mobile}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Date of Birth</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={convertDBDate(memberDetails.dob)}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Application ID</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={memberDetails.application_no}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Address</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={`${memberDetails.street_line1 || ""}, ${
                              memberDetails.street_line2 || ""
                            }, ${memberDetails.city || ""}, ${
                              memberDetails.state_name || ""
                            }, ${memberDetails.country_name || ""}, ${
                              memberDetails.pin || ""
                            }`}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Application Date</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={convertDBDate(memberDetails.member_reg_date)}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <h4>Joining Date</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <input
                            value={convertDBDate(memberDetails.joining_date)}
                            disabled
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="row pt-3">
                      <div className="col-md-12">
                        <div className="traking_status_d_dlex">
                          <div className="aplication_inner_div">
                            <p>Do you need your application details?</p>
                            <button
                              className="btn btn-outline-primary btn-block saveand_proced_button"
                              type="button"
                              onClick={() =>
                                sendDetailsToMail(memberDetails.id)
                              }
                            >
                              Send Details to Email
                            </button>
                          </div>
                          <div className="aplication_inner_div">
                            <p>Need further assistance?</p>
                            <button
                              className="btn btn-outline-primary btn-block saveand_proced_button"
                              type="button"
                              onClick={() => handleContactAMASIModalOpen()}
                            >
                              Contact AMASI
                            </button>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {memberDetails && (
              <div className="row know_user_member_application_div">
                <div className="col-md-6 card">
                  <div className="body p-4 shadow-sm mb-4">
                    <h5 className="mb-3">
                      <i className="fa fa-download me-2"></i>Get Complete
                      Application Details
                    </h5>
                    <p>
                      Receive your complete membership documentation via email
                    </p>
                    <p className="fw-bold mb-1">What you’ll receive:</p>
                    <ul className="ps-3">
                      <li>Basic Detail</li>
                      {/* <li>AMASI membership available via mobile app </li>
                    <li>Download from App Store or Play Store</li> */}
                      <li>Log in using email, password, or OTP</li>
                      <li>Access certificate in app or web portal</li>
                    </ul>
                    <div className="back_light_blue p-3 rounded mb-3">
                      <strong>Email will be sent to:</strong>{" "}
                      {memberDetails.email}
                      <br />
                      <small className="text-muted">
                        Documents are confidential and for your personal use
                        only.
                      </small>
                    </div>
                    <button
                      className="btn btn-outline-primary btn-block"
                      onClick={() => sendDetailsToMail(memberDetails.id)}
                    >
                      <i className="fa fa-file-text-o"></i> Send Details to My
                      Email
                    </button>
                  </div>
                </div>
                <div className="col-md-6 card">
                  <div className="body p-4 shadow-sm mb-4">
                    <h5 className="mb-3  ">
                      <i className="fa fa-question-circle me-2"></i>Need
                      Additional Support?
                    </h5>
                    <p>Get personalized assistance from our support team</p>
                    <p className="fw-bold mb-1">We can help you with:</p>
                    <ul className="ps-3">
                      <li>Password reset or account recovery assistance</li>
                      <li>Clarification on policies and procedures</li>
                      <li>Certificate verification</li>
                      <li>Notification and email delivery issues</li>
                      <li>Duplicate or missing certificate requests</li>
                      <li>Status tracking for submitted requests</li>
                    </ul>
                    <a
                      href="tel:+917358105244"
                      className="call_button_div btn btn-primary btn-block"
                    >
                      <div className="">
                        <i className="fa fa-phone me-2"></i>
                        <strong>Call:</strong> +91 7358105244
                      </div>
                    </a>
                    <button
                      className="btn btn-outline-primary btn-block mb-2"
                      onClick={() => handleContactAMASIModalOpen()}
                    >
                      <i className="fa fa-envelope me-2"></i>Email Support Team
                    </button>
                    <div className="text-muted small respond_time_div">
                      <strong className="text-danger">Response Time:</strong>{" "}
                      Within 24 hours on business days
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <Footer />
      </section>
      {contactAMASIModal && (
        <div className="modal fade d-block show">
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">Contact AMASI</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => handleContactAMASIModalClose()}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{
                  overflowY: "auto",
                  flex: "1 1 auto",
                  padding: "1rem",
                }}
              >
                {/* <div className="d-flex mb-3">
                  <div>
                    <h6 className="mb-0">
                      Would you like to change the application status
                    </h6>
                  </div>
                </div> */}
                <div className="form-group pos_relative">
                  <label>
                    First Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      contactAMASIErrors.first_name ? "red_border" : ""
                    }`}
                    value={contactAMASIFormValues.first_name}
                    onChange={(e) =>
                      handleInputChange("first_name", e.target.value)
                    }
                  />
                  {contactAMASIErrors && (
                    <p className="text-danger pos_abos">
                      {contactAMASIErrors.first_name}
                    </p>
                  )}
                </div>
                <div className="form-group pos_relative">
                  <label>Last Name</label>
                  <input
                    type="text"
                    // className={`form-control ${contactAMASIErrors.last_name ? 'red_border' : ''}`}
                    className={`form-control`}
                    value={contactAMASIFormValues.last_name}
                    onChange={(e) =>
                      handleInputChange("last_name", e.target.value)
                    }
                  />
                  {/* {contactAMASIErrors &&
                    <p className="text-danger pos_abos">
                      {contactAMASIErrors.last_name}
                    </p>} */}
                </div>
                <div className="form-group pos_relative">
                  <label>
                    Email ID <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${
                      contactAMASIErrors.email_id ? "red_border" : ""
                    }`}
                    value={contactAMASIFormValues.email_id}
                    onChange={(e) =>
                      handleInputChange("email_id", e.target.value)
                    }
                  />
                  {contactAMASIErrors && (
                    <p className="text-danger pos_abos">
                      {contactAMASIErrors.email_id}
                    </p>
                  )}
                </div>
                <div className="form-group pos_relative">
                  <label>
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control ${
                      contactAMASIErrors.mobile_number ? "red_border" : ""
                    }`}
                    value={contactAMASIFormValues.mobile_number}
                    onChange={(e) =>
                      handleInputChange("mobile_number", e.target.value)
                    }
                  />
                  {contactAMASIErrors && (
                    <p className="text-danger pos_abos">
                      {contactAMASIErrors.mobile_number}
                    </p>
                  )}
                </div>
                <div className="form-group pos_relative">
                  <label>
                    Membership Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control ${
                      contactAMASIErrors.member_no ? "red_border" : ""
                    }`}
                    value={contactAMASIFormValues.member_no}
                    onChange={(e) =>
                      handleInputChange("member_no", e.target.value)
                    }
                  />
                  {contactAMASIErrors && (
                    <p className="text-danger pos_abos">
                      {contactAMASIErrors.member_no}
                    </p>
                  )}
                </div>
                <div className="form-group pos_relative">
                  <label>
                    Subject <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      contactAMASIErrors.subject ? "red_border" : ""
                    }`}
                    value={contactAMASIFormValues.subject}
                    onChange={(e) =>
                      handleInputChange("subject", e.target.value)
                    }
                  />
                  {contactAMASIErrors && (
                    <p className="text-danger pos_abos">
                      {contactAMASIErrors.subject}
                    </p>
                  )}
                </div>
                <div className="form-group pos_relative">
                  <label>
                    Message <span className="text-danger">*</span>
                  </label>
                  <textarea
                    rows={4}
                    type="text"
                    className={`form-control ${
                      contactAMASIErrors.message ? "red_border" : ""
                    }`}
                    value={contactAMASIFormValues.message}
                    onChange={(e) =>
                      handleInputChange("message", e.target.value)
                    }
                  />
                  {contactAMASIErrors && (
                    <p className="text-danger pos_abos">
                      {contactAMASIErrors.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="modal-footer" style={{ flexShrink: 0 }}>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => handleContactAMASIModalClose()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => handleContactAMASIFormSubmit()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KnownUserMemberApplication;
